/**
 * @generated SignedSource<<e861ae257f82bc7d453a3fa293a72090>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contactFragment$data = {
  readonly id: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly source: string;
  readonly email: string;
  readonly accountId: string;
  readonly createdAt: any | null;
  readonly createdBy: string | null;
  readonly unmindUserId: string | null;
  readonly status: string;
  readonly salutation: string | null;
  readonly dob: any | null;
  readonly preferredName: string | null;
  readonly gender: string | null;
  readonly photoUrls: any | null;
  readonly countryId: string | null;
  readonly mobilePhone: string | null;
  readonly workPhone: string | null;
  readonly homePhone: string | null;
  readonly addressLineOne: string | null;
  readonly addressLineTwo: string | null;
  readonly city: string | null;
  readonly state: string | null;
  readonly businessName: string | null;
  readonly occupation: string | null;
  readonly contactActivityHistories: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"contactActivityHistoryInlineFragment">;
  }>;
  readonly contactTeamMembers: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"contactTeamMemberInlineFragment">;
  }>;
  readonly salesOrders: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseFragment" | "salesOrderAmountFragment" | "salesOrderPaymentsFragment" | "salesOrderBaseInlineFragment" | "salesOrderAmountInlineFragment" | "salesOrderPaymentsInlineFragment">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"contactSessionLimitsRemainingFragment" | "contactSessionLimitsRemainingInlineFragment">;
  readonly " $fragmentType": "contactFragment";
};
export type contactFragment$key = {
  readonly " $data"?: contactFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contactFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grandAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contactFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unmindUserId",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salutation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dob",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photoUrls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobilePhone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workPhone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "homePhone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addressLineOne",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "addressLineTwo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "occupation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactActivityHistory",
      "kind": "LinkedField",
      "name": "contactActivityHistories",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "contactActivityHistoryInlineFragment",
          "selections": [
            (v0/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v4/*: any*/),
            (v9/*: any*/)
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactTeamMember",
      "kind": "LinkedField",
      "name": "contactTeamMembers",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "contactTeamMemberInlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMember",
              "kind": "LinkedField",
              "name": "teamMember",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "memberUserProfile",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Fee",
              "kind": "LinkedField",
              "name": "fee",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "feeInlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    (v10/*: any*/),
                    (v4/*: any*/),
                    (v5/*: any*/),
                    (v11/*: any*/),
                    (v8/*: any*/),
                    (v12/*: any*/),
                    (v7/*: any*/)
                  ]
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesOrder",
      "kind": "LinkedField",
      "name": "salesOrders",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "salesOrderBaseFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "salesOrderAmountFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "salesOrderPaymentsFragment"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "salesOrderBaseInlineFragment",
          "selections": [
            (v0/*: any*/),
            (v12/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerEmail",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerFirstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "customerLastName",
              "storageKey": null
            },
            (v6/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v11/*: any*/),
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "eventRecurringId",
              "storageKey": null
            },
            (v4/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Payment",
              "kind": "LinkedField",
              "name": "payment",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "paymentBaseInlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "paidAt",
                      "storageKey": null
                    },
                    (v10/*: any*/),
                    (v11/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v15/*: any*/),
                    (v16/*: any*/)
                  ]
                }
              ],
              "storageKey": null
            }
          ]
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "salesOrderAmountInlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "subAmount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taxAmount",
              "storageKey": null
            },
            (v13/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discountAmount",
              "storageKey": null
            },
            (v14/*: any*/),
            (v11/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "paymentTerms",
              "storageKey": null
            }
          ]
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "salesOrderPaymentsInlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentIn",
              "kind": "LinkedField",
              "name": "paymentIns",
              "plural": true,
              "selections": [
                (v10/*: any*/),
                (v4/*: any*/),
                (v11/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "payerEmail",
                  "storageKey": null
                },
                (v12/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SalesOrder",
                  "kind": "LinkedField",
                  "name": "salesOrder",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contactSessionLimitsRemainingFragment"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "contactSessionLimitsRemainingInlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SessionLimitPayload",
          "kind": "LinkedField",
          "name": "sessionLimits",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sessionLimitType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expiryDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Contact",
  "abstractKey": null
};
})();

(node as any).hash = "2cc34a75210935eb2be1044e657e0e3c";

export default node;
